import PropTypes from 'prop-types'
import { isNil, pathOr } from 'ramda'
import ActiveRecord from '../activeRecord'
import User from '../person/user'

class Upload extends ActiveRecord {
  constructor(init) {
    super(init)
    if (isNil(init)) return undefined
    // todo create model for attached_to
    this._attached_to = pathOr({}, ['attached_to'], init)
    this._content_type = init.content_type
    this._display_type = init.display_type
    this._short_url = init.short_url
    this._ticket = init.ticket
    this._title = init.title
    this._type = init.type
    this._user = new User(init.user)
  }

  static shape = {
    attached_to: PropTypes.object.isRequired,
    content_type: PropTypes.string.isRequired,
    display_type: PropTypes.string.isRequired,
    short_url: PropTypes.string.isRequired,
    ticket: PropTypes.object,
    title: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    user: PropTypes.instanceOf(User).isRequired
  }

  get attached_to() {
    return this._attached_to
  }

  get content_type() {
    return this._content_type
  }

  get display_type() {
    return this._display_type
  }

  get short_url() {
    return this._short_url
  }

  get ticket() {
    return this._ticket
  }

  get title() {
    return this._title
  }

  get type() {
    return this._type
  }

  get user() {
    return this._user
  }
}

export default Upload
